export default server => ({
    async login(email, password) {
        const {data} = await server.post('auth/login', {email, password});
        return data
    },
    async store(email, password, captcha) {
        const {data} = await server.post('auth/registration', {email, password, 'g-recaptcha-response': captcha});
        return data;
    },

    async update(id, fields) {
        let {data} = await server.patch(`users/${id}`, fields);
        return data;
    },


    /* async check() {
         let {data} = await server.get('auth/check', {
             errorSuppression: {},
             silence401: true
         });
         return data;
     },*/
    /*    async logout() {
            let {data} = await server.get('auth/logout.php', {
                errorSuppression: {text: 'при выходе с сайта'}
            });
            return data;
        }*/
});